import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, HelpCircle } from "lucide-react";

const FAQAccordion = () => {
  const { t, i18n } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const isRTL = i18n.language === 'ar';

  const faqs = [
    {
      question: t('faq.howItWorks.question'),
      answer: t('faq.howItWorks.answer')
    },
    {
      question: t('faq.supportedLanguages.question'),
      answer: t('faq.supportedLanguages.answer')
    },
    {
      question: t('faq.voiceTranslation.question'),
      answer: t('faq.voiceTranslation.answer')
    },
    {
      question: t('faq.audioNotWorking.question'),
      answer: t('faq.audioNotWorking.answer')
    },
    {
      question: t('faq.isFree.question'),
      answer: t('faq.isFree.answer')
    },
    {
      question: t('faq.dataSafe.question'),
      answer: t('faq.dataSafe.answer')
    },
    {
      question: t('faq.changeLanguage.question'),
      answer: t('faq.changeLanguage.answer')
    }
  ];

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 mb-6" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="flex items-center gap-2 mb-4">
        <HelpCircle className="w-5 h-5 text-[#0EA5E9]" />
        <h3 className="text-lg font-semibold text-ocean">{t('faq.title')}</h3>
      </div>
      
      <div className="space-y-2">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-slate-100 rounded-xl overflow-hidden"
            data-testid={`faq-item-${index}`}
          >
            <button
              onClick={() => toggleItem(index)}
              className={`w-full flex items-center justify-between p-4 text-${isRTL ? 'right' : 'left'} hover:bg-slate-50 transition-colors`}
              aria-expanded={openIndex === index}
              data-testid={`faq-question-${index}`}
            >
              <span className="font-medium text-travel-navy text-sm pr-2">{faq.question}</span>
              <ChevronDown 
                className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform duration-200 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            
            <div
              className={`overflow-hidden transition-all duration-200 ease-in-out ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="px-4 pb-4">
                <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-line">
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQAccordion;
